module.exports = __webpack_public_path__ + "media/images/edit-icon-d1d4b8826addb653a7eab31c686b6b5c.png";